import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { ThemeProvider } from "./theme";
import Navbar from "./components/navbar/Navbar";
import urlEnd from "./components/endpoints/Endpoints";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import Terms from "./components/termAndConditions/terms";
import Page2026Scratch from "./components/page2026/Page2026Scratch";

function AppContent() {
  const location = useLocation();
  const is2026Page = location.pathname === "/";

  return (
    <>
      {!is2026Page && <Navbar />}
      <Routes>
        {/* <Route exact path={`${urlEnd}`} element={<Home />} index={true} /> */}
        <Route
          exact
          path={`${urlEnd}`}
          element={<Page2026Scratch />}
          index={true}
        />
        {/* Redirect old routes to home */}
        <Route
          exact
          path={`${urlEnd}about`}
          element={<Navigate to={urlEnd} replace />}
        />
        <Route
          exact
          path={`${urlEnd}howitwork`}
          element={<Navigate to={urlEnd} replace />}
        />
        <Route
          exact
          path={`${urlEnd}plans`}
          element={<Navigate to={urlEnd} replace />}
        />
        <Route
          exact
          path={`${urlEnd}security`}
          element={<Navigate to={urlEnd} replace />}
        />
        {/* <Route exact path={`${urlEnd}resources`} element={<Resources />} /> */}
        <Route
          exact
          path={`${urlEnd}contact`}
          element={<Navigate to={urlEnd} replace />}
        />
        <Route
          exact
          path={`${urlEnd}privacy-policy`}
          element={<PrivacyPolicy />}
        />
        <Route exact path={`${urlEnd}terms`} element={<Terms />} />
        <Route exact path="/2024" element={<Navigate to={urlEnd} replace />} />
        <Route
          exact
          path="/2026ver2"
          element={<Navigate to={urlEnd} replace />}
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
